// Servicio para enviar el perfil del operario al backend
// Comentario: encapsula la llamada al endpoint /usuario/perfil

import api from './api'; // Axios configurado con baseURL y Authorization

export type PerfilPayload = { // Estructura del payload que espera el backend
  escolaridad: string; // Escolaridad seleccionada
  ciudad: string; // Ciudad en texto libre
  barrio: string; // Barrio en texto libre
  direccion: string; // Dirección completa
  latitud: number; // Latitud numérica
  longitud: number; // Longitud numérica
  contactoNombre: string; // Nombre del contacto
  contactoTelefono: string; // Teléfono local (el backend normaliza a +595)
  // agregar correo electrónico personal del operario al payload
  emailPersonal: string; // Correo electrónico personal
  movilidad: string[]; // Arreglo con selección de movilidad ("Moto", "Auto") o ["No"]
};

export async function putPerfilOperario(payload: PerfilPayload): Promise<void> { // Envía el payload al backend
  // Enviamos el payload tal cual; el backend se encargará de persistir la movilidad
  await api.put('/usuario/perfil', payload); // Llamada HTTP PUT
}

export type EstadoPerfil = { // Respuesta del backend para decidir el banner
  needsUpdate: boolean; // Si hace falta actualización
  missingFields: string[]; // Campos faltantes
  lastUpdatedAt: string | null; // Fecha de última actualización
  versionActualRequerida?: number | null; // Versión exigida por la campaña vigente
  versionUsuario?: number | null; // Versión del último perfil guardado por el usuario
};

export async function getEstadoPerfil(): Promise<EstadoPerfil> { // Consulta el estado del perfil
  const { data } = await api.get('/usuario/estado_perfil');
  return data as EstadoPerfil;
}

// Respuesta del endpoint que valida si la ubicación cae dentro de un PS (50 m)
export type ValidacionUbicacionPerfil = {
  permitido: boolean;
  distancia_m: number | null;
  ps_cercano: string | null;
};

export async function validarUbicacionPerfil(lat: number, lng: number): Promise<ValidacionUbicacionPerfil> {
  const { data } = await api.get('/usuario/validar_ubicacion_perfil', {
    params: { latitud: lat, longitud: lng },
  });
  return data as ValidacionUbicacionPerfil;
}

export type PerfilDTO = { // DTO que devuelve el backend en GET /usuario/perfil
  perfil: null | {
    escolaridad: string | null;
    ciudad: string | null;
    barrio: string | null;
    direccion: string | null;
    latitud: number | null;
    longitud: number | null;
    contactoNombre: string | null;
    contactoTelefono: string | null;
    // incluir el correo personal provisto por el backend
    emailPersonal: string | null;
    movilidad: string | null; // lista separada por comas o 'No'
    lastUpdatedAt: string | null;
  };
};

export async function getPerfilOperario(): Promise<PerfilDTO> { // Obtiene último perfil del backend
  const { data } = await api.get('/usuario/perfil');
  return data as PerfilDTO;
}
